export const ROUTER_MAIN = '/main'

export const ROUTER_INIT = '/'
